/* eslint-disable import/prefer-default-export */
import mobileImage from "../assets/icons/mobile-icon.svg";

const bankDetailsOptions = [
  {
    title: "Verify using UPI",
    description: "Pay ₹1 from your bank account you wish to link via UPI. The amount will refunded in 2 business days.",
    value: "pennyDrop",
    image: mobileImage,
    key: "rpd",
  },
  {
    title: "Verify Manually",
    description: "Verify using IFSC and Account Number",
    value: "manual",
    key: "penny_drop",
  },
]
export { bankDetailsOptions };
